<template>

	<div class="container mt-5" v-if="book === false || shelf === false">
		<p>loading ...</p>
	</div>
	<template v-else-if="book && shelf">

		<div class="bg-white py-2">
			<div class="container">
				<div class="d-md-flex align-items-center flex-row-reverse">

					<div class="ms-auto float-end mt-1 mt-md-0">
						<div class="hstack gap-4 justify-content-end">
							<div class="d-none d-lg-block">
<!--								<label class="file-choose btn btn-primary">-->
<!--									<input type="file" accept="image/*" @change="chooseFile" multiple>-->
<!--									Добавить&nbsp;слайды-->
<!--								</label>-->

								<button type="button" class="btn btn-primary" @click="openFilesUploader">Добавить&nbsp;слайды</button>

							</div>

							<div class="dropdown">
								<button type="button" class="btn btn-link d-flex align-items-center p-0 text-decoration-none" data-bs-toggle="dropdown">
									<svg width="36" height="24" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
										<g fill="currentColor">
											<path d="M30.391,12.68l-3.064-0.614c-0.154-0.443-0.336-0.873-0.537-1.289l1.736-2.604   c0.529-0.793,0.424-1.85-0.25-2.523l-1.924-1.924c-0.387-0.387-0.898-0.586-1.416-0.586c-0.383,0-0.77,0.11-1.107,0.336   l-2.604,1.735c-0.418-0.202-0.848-0.382-1.291-0.536L19.32,1.61c-0.186-0.936-1.008-1.608-1.961-1.608h-2.72   c-0.953,0-1.774,0.673-1.961,1.608l-0.614,3.065c-0.443,0.154-0.873,0.335-1.289,0.536L8.172,3.476   C7.833,3.25,7.447,3.14,7.063,3.14c-0.517,0-1.028,0.199-1.415,0.586L3.725,5.65c-0.674,0.674-0.779,1.73-0.25,2.523l1.735,2.604   c-0.202,0.417-0.382,0.847-0.536,1.29L1.608,12.68C0.673,12.867,0,13.688,0,14.641v2.72c0,0.953,0.673,1.775,1.608,1.961   l3.065,0.615c0.154,0.443,0.335,0.873,0.536,1.289L3.475,23.83c-0.529,0.793-0.424,1.85,0.25,2.523l1.924,1.924   c0.387,0.387,0.898,0.586,1.415,0.586c0.384,0,0.771-0.111,1.108-0.336l2.604-1.736c0.417,0.203,0.847,0.383,1.29,0.537   l0.613,3.064c0.187,0.936,1.008,1.609,1.961,1.609h2.72c0.953,0,1.775-0.674,1.961-1.609l0.615-3.064   c0.443-0.154,0.873-0.336,1.289-0.537l2.604,1.736c0.338,0.225,0.725,0.336,1.107,0.336c0.518,0,1.029-0.199,1.416-0.586   l1.924-1.924c0.674-0.674,0.779-1.73,0.25-2.523l-1.736-2.604c0.203-0.418,0.383-0.848,0.537-1.291l3.064-0.613   C31.326,19.137,32,18.314,32,17.361v-2.72C32,13.688,31.326,12.867,30.391,12.68z M26.934,17.975   c-0.695,0.139-1.264,0.635-1.496,1.305c-0.129,0.369-0.279,0.727-0.447,1.074c-0.311,0.639-0.258,1.393,0.135,1.982l1.736,2.604   l-1.924,1.924l-2.604-1.736c-0.334-0.223-0.721-0.336-1.109-0.336c-0.297,0-0.596,0.066-0.871,0.199   c-0.348,0.168-0.705,0.32-1.076,0.449c-0.668,0.232-1.164,0.801-1.303,1.496l-0.615,3.066h-2.72l-0.613-3.066   c-0.139-0.695-0.635-1.264-1.304-1.496c-0.369-0.129-0.728-0.279-1.075-0.447c-0.276-0.135-0.574-0.201-0.872-0.201   c-0.389,0-0.775,0.113-1.109,0.336l-2.604,1.736l-1.924-1.924l1.735-2.604c0.393-0.59,0.444-1.344,0.137-1.98   c-0.168-0.348-0.319-0.705-0.448-1.076c-0.232-0.668-0.802-1.164-1.496-1.303l-3.065-0.615L2,14.641l3.066-0.613   c0.694-0.139,1.264-0.635,1.496-1.304c0.129-0.369,0.278-0.728,0.447-1.075c0.31-0.638,0.258-1.392-0.136-1.981L5.139,7.064   L7.062,5.14l2.604,1.735C10,7.098,10.387,7.211,10.775,7.211c0.297,0,0.595-0.066,0.871-0.199c0.347-0.168,0.705-0.319,1.075-0.448   c0.669-0.232,1.165-0.802,1.304-1.496l0.614-3.065l2.72-0.001l0.613,3.066c0.139,0.694,0.635,1.264,1.305,1.496   c0.369,0.129,0.727,0.278,1.074,0.447c0.277,0.134,0.574,0.2,0.873,0.2c0.389,0,0.775-0.113,1.109-0.336l2.604-1.735l1.924,1.924   l-1.736,2.604c-0.393,0.59-0.443,1.343-0.137,1.98c0.168,0.347,0.32,0.705,0.449,1.075c0.232,0.669,0.801,1.165,1.496,1.304   l3.064,0.614L30,17.361L26.934,17.975z"/>
											<path d="M16,9.001c-3.865,0-7,3.135-7,7c0,3.866,3.135,7,7,7s7-3.135,7-7C23,12.136,19.865,9.001,16,9.001z    M16,22.127c-3.382,0-6.125-2.744-6.125-6.125c0-3.382,2.743-6.125,6.125-6.125c3.381,0,6.125,2.743,6.125,6.125   C22.125,19.383,19.381,22.127,16,22.127z"/>
											<path d="M16,12.001c-2.21,0-4,1.79-4,4c0,2.209,1.79,4,4,4c2.209,0,4-1.791,4-4C20,13.792,18.209,12.001,16,12.001z    M16,19.002c-1.656,0-3-1.344-3-3c0-1.656,1.344-3,3-3s3,1.344,3,3C19,17.658,17.656,19.002,16,19.002z"/>
										</g>
									</svg>
									<span class="ms-1 d-none d-xxl-block">действия</span>
								</button>
								<nav class="dropdown-menu dropdown-menu-end">
									<a href="#" class="dropdown-item" @click.prevent="edit">Редактировать книгу</a>
									<a href="#" class="dropdown-item text-danger" @click.prevent="remove">Удалить книгу</a>
								</nav>
							</div>
						</div>
					</div>

					<app-breadcrumbs :items="[
						{name: category.title, url: {name: category.routerName}},
						{name: shelf.name, url: {name: 'shelf-view', params: {idShelf: shelf.id}}},
					]">
						<h1 class="title-primary m-0">{{book.name}}</h1>
					</app-breadcrumbs>

				</div>
			</div>
		</div>

		<div class="container mt-5">

			<div class="row align-items-stretch gx-3 gx-sm-5">
				<div v-if="book.image" class="col-4 col-md-auto">
					<div class="bg-white p-1 p-sm-2" style="max-width: 150px">
						<figure class="text-center">
							<img :src="picture(book.image, 200)">
						</figure>
					</div>
				</div>
				<div class="col-8 col-md align-self-center">

					<div v-if="fields.length" class="mt-n2 params">
						<div v-for="(group, groupKey) in fields" :key="'fields-group'+groupKey" class="row align-items-end gx-md-5 my-0">
							<div v-for="(item, key) of group" :key="key" class="col-auto mt-2">
								<p>
									<template v-if="item.name">
										<small class="text-muted">{{item.name}}</small>
										<br>
									</template>
									{{item.val}}
								</p>
							</div>
						</div>
					</div>

				</div>
			</div>

			<div v-if="Array.isArray(book.images)" class="mt-5">

				<div v-if="book.images.length" class="mx-sm-0 p-1 p-sm-0" style="margin: 0 -15px;" :class="{
					'books_edit-mode': editMode
				}">
					<draggable
						tag="div"
						class="row g-1 g-sm-2 g-lg-3"
						:list="book.images"
						handle=".drag--handle"
						ghost-class="book-slide_ghost"
						item-key="id"
						@sort="filesDragFinishEvent"
						>
						<template #item="{ element, index }">
							<div class="col-6 col-sm-4 col-md-3">
								<div class="book-slide" :class="{
									'book-slide_checked': element.checked
								}">
									<div class="book-slide__body">
										<a href="#" class="book-slide__cover"
											@click.prevent="showGallery(index)"
										>
											<img :src="picture(element.image, 400, 300)" class="book-slide__image">
										</a>

										<div class="book-slide__caption" v-if="element.comment">{{element.comment}}</div>

										<div class="book-slide__toolbar">
											<label title="Переместить" class="btn book-slide__control book-slide__drag-btn drag--handle">
												<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
													<path d="M11 11V5.828L9.172 7.657 7.757 6.243 12 2l4.243 4.243-1.415 1.414L13 5.828V11h5.172l-1.829-1.828 1.414-1.415L22 12l-4.243 4.243-1.414-1.415L18.172 13H13v5.172l1.828-1.829 1.415 1.414L12 22l-4.243-4.243 1.415-1.414L11 18.172V13H5.828l1.829 1.828-1.414 1.415L2 12l4.243-4.243 1.414 1.415L5.828 11z"/>
												</svg>
											</label>

											<input type="checkbox" v-model="element.checked" title="Отметить" class="form-check-input book-slide__control book-slide__checkbox">
										</div>

										<div class="book-slide__toolbar book-slide__toolbar_pos-be">
											<button title="Сменить подпись" type="button" class="btn book-slide__control" @click="editFileCaption(element)">
												<svg width="24" height="24" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
													<path d="M10 34v4h28v-4H10zm9-8.4h10l1.8 4.4H35L25.5 8h-3L13 30h4.2l1.8-4.4zm5-13.64L27.74 22h-7.48L24 11.96z"/>
												</svg>
											</button>
										</div>

									</div>
								</div>
							</div>
						</template>

						<template #footer>
							<div class="col-6 col-sm-4 col-md-3">
<!--								<label class="file-choose btn bg-white btn-link d-flex flex-column align-items-center justify-content-center h-100 p-3" style="line-height: 1.1;">-->
<!--									<input type="file" accept="image/*" @change="chooseFile" multiple>-->
								<label @click="openFilesUploader" class="btn bg-white btn-link d-flex flex-column align-items-center justify-content-center h-100 p-3" style="line-height: 1.1;">
									<svg width="48" height="48" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
										<path fill="currentColor" d="M18.5 20C18.5 20.275 18.276 20.5 18 20.5H12.2678C11.9806 21.051 11.6168 21.5557 11.1904 22H18C19.104 22 20 21.104 20 20V9.828C20 9.298 19.789 8.789 19.414 8.414L13.585 2.586C13.57 2.57105 13.5531 2.55808 13.5363 2.5452C13.5238 2.53567 13.5115 2.5262 13.5 2.516C13.429 2.452 13.359 2.389 13.281 2.336C13.2557 2.31894 13.2281 2.30548 13.2005 2.29207C13.1845 2.28426 13.1685 2.27647 13.153 2.268C13.1363 2.25859 13.1197 2.24897 13.103 2.23933C13.0488 2.20797 12.9944 2.17648 12.937 2.152C12.74 2.07 12.528 2.029 12.313 2.014C12.2933 2.01274 12.2738 2.01008 12.2542 2.00741C12.2271 2.00371 12.1999 2 12.172 2H6C4.896 2 4 2.896 4 4V11.4982C4.47417 11.3004 4.97679 11.1572 5.5 11.0764V4C5.5 3.725 5.724 3.5 6 3.5H12V8C12 9.104 12.896 10 14 10H18.5V20ZM13.5 4.621L17.378 8.5H14C13.724 8.5 13.5 8.275 13.5 8V4.621Z"/>
										<path fill="currentColor" d="M12 17.5C12 14.4624 9.53757 12 6.5 12C3.46243 12 1 14.4624 1 17.5C1 20.5376 3.46243 23 6.5 23C9.53757 23 12 20.5376 12 17.5ZM7.00065 18L7.00111 20.5035C7.00111 20.7797 6.77725 21.0035 6.50111 21.0035C6.22497 21.0035 6.00111 20.7797 6.00111 20.5035L6.00065 18H3.4956C3.21973 18 2.99609 17.7762 2.99609 17.5C2.99609 17.2239 3.21973 17 3.4956 17H6.00046L6 14.4993C6 14.2231 6.22386 13.9993 6.5 13.9993C6.77614 13.9993 7 14.2231 7 14.4993L7.00046 17H9.49659C9.77246 17 9.99609 17.2239 9.99609 17.5C9.99609 17.7762 9.77246 18 9.49659 18H7.00065Z"/>
									</svg>
									<span class="d-block mt-2">Добавить слайды</span>
								</label>
							</div>
						</template>
					</draggable>

				</div>
				<div v-else class="text-center mt-5 mb-4">

<!--					<label class="file-choose btn btn-primary">-->
<!--						<input type="file" accept="image/*" @change="chooseFile" multiple>-->
<!--						Добавить слайды-->
<!--					</label>-->
					<button type="button" class="btn btn-primary" @click="openFilesUploader">Добавить слайды</button>

					<div class="small mt-3">
						<p>выберите одно или несколько изображений для загрузки</p>
					</div>

				</div>

			</div>

		</div>

		<vue-easy-lightbox
			:visible="gallery.visible"
			:index="gallery.index"
			:imgs="images"
			@hide="closeGallery"
		></vue-easy-lightbox>

		<fab-dropdown autoClose="outside" v-slot="{hide}" :checked="{
			value: checkedFiles.length,
			total: book.images.length
		}">

			<div v-if="editMode" class="fab-dropdown__section" data-label="Действия с выбранными слайдами">
				<a href="#" class="dropdown-item" @click.prevent="checkAllFiles">Выбрать все слайды</a>
				<a href="#" class="dropdown-item" @click.prevent="uncheckFiles">Отменить выбранное</a>
				<a href="#" class="dropdown-item link-danger" @click.prevent="removeCheckedFiles(), hide()">Удалить выбранные слайды</a>
			</div>

			<a href="#" class="dropdown-item" @click.prevent="toggleEditMode(); hide();">
				<strong v-if="editMode">Выключить режим редактирования</strong>
				<span v-else>Включить режим редактирования</span>
			</a>

<!--			<label class="file-choose dropdown-item" @click="hide">-->
<!--				<input type="file" accept="image/*" @change="chooseFile" multiple>-->
<!--				Добавить слайды-->
<!--			</label>-->
			<a href="#" class="dropdown-item" @click.prevent="openFilesUploader(); hide();">Добавить слайды</a>

		</fab-dropdown>

	</template>


</template>
<script>
import SHELF from '@/models/shelf'
import CATEGORY from '@/models/category'
import FabDropdown from '@/components/fab-dropdown'
import BookModal from '@/modals/book-instance'
import FilesUploader from '@/modals/files-uploader'
import draggable from 'vuedraggable'
import { useToast } from 'vue-toastification'

const fieldsConfig = {
	author: {name: 'Автор'},
	illustrator: {name: 'Иллюстратор'},
	publish_house: {name: 'Издательство'},
}

export default {
	setup() {

		const toast = useToast();

		return {
			toast
		}
	},

	data() {
		return {
			editMode: false,

			book: null,
			shelf: null,
			category: null,

			gallery: {
				index: 0,
				visible: false,
			},

			// infoParams: {
			// 	author: {label: 'Автор', labelMob: 'Авт.', value: null},
			// 	illustrator: {label: 'Иллюстратор', labelMob: 'Ил.', value: null},
			// 	publish_house: {label: 'Издательство', labelMob: 'Изд.', value: null},
			// },
		}
	},
	computed: {
		// supportTouchEvent() {
		// 	return window.matchMedia('(pointer: coarse)').matches;
		// },

		fields() {
			let defaults = [];
			let custom = this.book.custom;

			for (let key in fieldsConfig) {
				const val = this.book[key]?.trim();
				val && defaults.push({name: fieldsConfig[key].name, val});
			}

			custom = Array.isArray(custom) ? custom.filter(item => !!item.val.trim()) : [];

			return [
				defaults,
				custom
			];
		},

		images() {
			return this.book.images.map(file => {
				return {
					src: this.picture(file.image),
					title: file.comment
				};
			});
		},

		checkedFiles() {
			return this.book.images.filter(item => item.checked);
		},
	},
	methods: {

		showGallery(index) {
			this.gallery.index = index;
			this.gallery.visible = true;
		},

		closeGallery() {
			this.gallery.visible = false;
		},

		toggleEditMode() {
			this.editMode = !this.editMode;

			if (!this.editMode) {
				this.checkedFiles.forEach(item => item.checked = false);
			}
		},

		loadBook(idBook, idShelf) {
			this.book = false;

			this.userapi.get(`racks/${idShelf}/${idBook}`)
				.then(response => {
					this.book = response.data.data || false;
				})
				.catch(() => this.book = null);
		},

		loadShelf(id) {
			this.shelf = false;

			this.userapi.get(`racks/${id}`).then(response => {
				this.shelf = response.data.id ? SHELF.formatServerData(response.data) : null;
				this.category = this.shelf ? CATEGORY.find(this.shelf.category) : null;
			}).catch(() => this.shelf = null);
		},

		openFilesUploader() {
			this.$vfm.show({component: FilesUploader}, {
				files: [],
				requestUrl: `racks/${this.shelf.id}/${this.book.id}/add-image`,
				onFileSave: (mode, data) => {
					if (mode === 'add') {
						this.book.images.push(data);
					}
				}
			});
		},

		chooseFile(e) {
			const files = e.target.files;

			if (files.length) {
				this.$vfm.show({component: FilesUploader}, {
					files: files,
					requestUrl: `racks/${this.shelf.id}/${this.book.id}/add-image`,
					onFileSave: (mode, data) => {
						if (mode === 'add') {
							this.book.images.push(data);
						}
					}
				});
			}
		},

		edit() {
			this.$vfm.show({component: BookModal}, {
				idBook: this.book.id,
				shelf: this.shelf,
				onSuccess: (mode, data) => {
					if (mode === 'edit') {
						this.book = data;
					}
				}
			});
		},

		remove() {
			const book  = this.book;
			const shelf = this.shelf;

			if (!confirm(`Удалить книгу "${book.name}"?`)) return;

			this.userapi.post(`racks/${shelf.id}/delete/${book.id}`).then(response => {
				parseInt(response.data.result) && this.$router.push({name: 'shelf-view', params: {idShelf: shelf.id}})
			});
		},

		uncheckFiles() {
			this.checkedFiles.forEach(file => file.checked = false);
		},

		checkAllFiles() {
			this.book.images.forEach(file => file.checked = true);
		},

		editFileCaption(file) {
			const result = prompt('Смена подписи к изображению', file.comment);

			if (result === null || result === file.comment) {
				return;
			}

			const requestUrl = `racks/${this.shelf.id}/${this.book.id}/edit-image/${file.id}`;

			this.userapi.post(requestUrl, new URLSearchParams({comment: result})).then(response => {
				if (!response.hasValidateErrors && response.data.data.id) {
					file.comment = response.data.data.comment;
				}
			});
		},

		filesDragFinishEvent() {
			this.resortFiles(this.book.images)?.then(response => {
				this.toast.success('Новый порядок слайдов сохранен', {
					timeout: 1500
				});
			});
		},

		resortFiles(files) {

			if (!Array.isArray(files)) {
				return null;
			}

			const requestUrl = `racks/${this.shelf.id}/${this.book.id}/sort-image`;
			const request = new FormData;

			files.forEach(file => request.append('ids[]', file.id));

			return this.userapi.post(requestUrl, request);
		},

		removeCheckedFiles() {
			const files = this.checkedFiles;

			if (!files.length) return;

			if (!confirm(`Удалить выбранные слайды (${files.length} шт.) ?`)) return;

			const requestUrl = `racks/${this.shelf.id}/${this.book.id}/remove-image`;
			const request = new URLSearchParams({
				ids: files.map(file => file.id).join(' ')
			});

			this.userapi.post(requestUrl, request).then(response => {
				const idsDeleted = response.data.ids || [];

				if (Array.isArray(idsDeleted) && idsDeleted.length) {
					this.book.images = this.book.images.filter(item => idsDeleted.indexOf(item.id) === -1);
				}
			});
		}
	},
	mounted() {
		const route = this.$route.params;

		this.loadBook(route.idBook, route.idShelf);
		this.loadShelf(route.idShelf);
	},
	components: {
		FabDropdown,
		draggable
	}
}
</script>
<style lang="sass" scoped>
.params
	width: 100%

	th
		width: 150px
		font-weight: normal
		padding-right: 1.5rem

	th,
	td
		padding-top: 0.25rem
		padding-bottom: 0.25rem

	td
		word-break: break-word
@media screen and (max-width: map-get($grid-breakpoints, sm) - 1)
	.params
		font-size: 0.9em

		small
			font-size: 12px
</style>